<template lang="html">
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex
        v-for="bus in buses"
        :key="bus.id"
        xs12
        md4>
        <bus-card
          :operator="operatorId"
          :bus="bus"
          :rates="ratesByBusTypeMap[bus.id]"
          text="Click the pencil icon to edit"
          :allowEdit="true"
          @deleteBus="deleteBusType"
          @updateBus="updateBusType"
          @createRate="createRate"
          @updateRate="updateRate"
          @deleteRate="deleteRate"/>
      </v-flex>
      <v-flex xs12 md4>
        <bus-card
          :operator="operatorId"
          text="You must finish creating before modifying rates"
          :allowEdit="true"
          @createBus="initCreateBus"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BusCard from '@/components/busie/BusCard';
export default {
  components: {
    'bus-card': BusCard,
  },
  props: {},
  data () {
    return {

    }
  },
  computed: {
    buses () {
      return this.busTypes.filter(bt => !!bt)
    },
    operator () {
      return this.operatorId
    },
    ...mapGetters('vehicles', {
      busTypes: 'types',
      ratesByBusTypeMap: 'ratesByTypeMap'
    }),
    ...mapGetters('operator', { operatorId: 'id' })
  },
  methods: {
    initCreateBus (payload) {
      const { rateSchemas } = payload
      const schema = rateSchemas[0]
      const rate = {
        name: schema.name,
        rule: {
          type: schema.rule.type,
          value: schema.rule.value
        },
        rates: [ schema.rates[0] ],
      }
      delete payload.rateSchemas
      return this.createBusType(payload).then(bus => {
        rate.busType = bus.id
        return this.createRate(rate)
      }).catch(e => this.raiseError(e))
    },
    ...mapActions('vehicles', [
      'createBusType',
      'updateBusType',
      'deleteBusType',
      'createRate',
      'updateRate',
      'deleteRate'
    ]),
    ...mapActions('app', ['raiseError'])
  }

}
</script>

<style lang="css" scoped>
</style>
